module.exports = __webpack_public_path__ + "img/icon_map_62_on_010.09593c14.png";